export type Encodable = Parameters<typeof encodeURIComponent>[0];
type Nullable<T> = T | null | undefined;
export default function objectToQueryString (
  obj: Record<string, Nullable<Encodable> | Nullable<Encodable>[]>,
): string {
  const state = createState();
  return Object.keys(obj).reduce(function (str: string, key: string) {
    const objVal = obj[key as keyof typeof obj];
    if (Array.isArray(objVal)) {
      return objVal.reduce(function (str1: string, objval: Nullable<Encodable>) {
        return generateURIComponent(str1, state, key + '[]', objval);
      }, str);
    } else {
      return generateURIComponent(str, state, key, objVal);
    }
  }, '');
}

function generateURIComponent (
  str: string,
  state: ReturnType<typeof createState>,
  key: Encodable,
  objval: Nullable<Encodable>,
) {
  let encoded = str;
  if (objval !== null && objval !== undefined) {
    const encKey = encodeURIComponent(key);
    const encVal = encodeURIComponent(objval);
    encoded = [str, state.getDelimiter(), encKey, '=', encVal].join('');
    state.isFirst = false;
  }
  return encoded;
}
function createState () {
  return {
    isFirst: true,
    getDelimiter () {
      return this.isFirst ? '?' : '&';
    },
  };
}
